import 'react-app-polyfill/stable';
import 'core-js';
import React from 'react';
import {createRoot} from 'react-dom/client';
import App from './App';
//import reportWebVitals from './reportWebVitals';
import {Provider} from 'react-redux';
import {PersistGate} from 'redux-persist/integration/react';
import {APIProvider} from '@vis.gl/react-google-maps';
import {
  persistor, 
  store,
} from './store';

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAP_API_KEY} version="3.64">
        <App />
      </APIProvider>
    </PersistGate>
  </Provider>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
